// ================================================================
//  <bm-duration> — one shared days/hours/minutes duration renderer,
//  clock icon + colored badge, for every "how long has X been true"
//  reading in the app (interceptor/environment uptime, offline-for,
//  in-standby-for, unreachable-for, runtime instance uptime, ...).
//
//  Consolidates what used to be several independently-hand-rolled
//  "totalMinutes / days / hours / minutes" computations that had quietly
//  drifted apart (one of them stayed at "Xh Ym" with no days component
//  long after the others gained one) — now there is exactly one place
//  that turns a timestamp into "2d 3h 15m", so nothing can drift again.
//
//  Usage:
//    <bm-duration since="vm.stats.session_started_at"
//                 label="'Uptime'" variant="'success'">
//    </bm-duration>
//
//    <!-- Compact — no padding/background/label, just icon + text, for a
//         tight table cell. -->
//    <bm-duration since="env.session_started_at" compact="true"></bm-duration>
//
//  Bindings:
//    since   ('<') epoch millis, or null/undefined — renders "Unknown"
//            when missing rather than "0h 0m" (a caller with no
//            meaningful "since" at all — e.g. an OFFLINE environment
//            asked for its own uptime — should read as unknown, not as a
//            real zero duration).
//    label   ('@') optional caption under the value ("Uptime", "Offline
//            for", ...) — ignored in compact mode, there's no room for it.
//    variant ('@') 'neutral' (default) | 'success' | 'warning' | 'info' | 'danger'
//            — background/text/icon color, matching the app's existing
//            green/amber/red state language.
//    compact   ('<') boolean — strips padding/background/border and the
//              label, for table cells and other tight spaces that just
//              need the icon + value inline.
//    emptyText ('@') shown in place of the value when `since` is missing
//              — defaults to 'Unknown' (fine for a standalone tile), but
//              a table cell sitting next to other metrics that all fall
//              back to '—' should pass empty-text="—" to match them.
// ================================================================

angular.module('bizmetryApp').component('bmDuration', {
  bindings: {
    since: '<',
    label: '@',
    variant: '@',
    compact: '<',
    emptyText: '@'
  },
  template: `
    <span class="bm-duration"
          ng-class="['bm-duration--' + ($ctrl.variant || 'neutral'), $ctrl.compact ? 'bm-duration--compact' : '']">
      <md-icon class="bm-duration-icon">schedule</md-icon>
      <span class="bm-duration-text">
        <span class="bm-duration-value">{{ $ctrl.formatted() }}</span>
        <span class="bm-duration-label" ng-if="$ctrl.label && !$ctrl.compact">{{ $ctrl.label }}</span>
      </span>
    </span>
  `,
  controller: function () {
    var vm = this;

    // Days omitted when 0 so a freshly-started process still reads as a
    // clean "Xh Ym" instead of a noisy "0d Xh Ym".
    vm.formatted = function () {
      if (!vm.since) { return vm.emptyText || 'Unknown'; }
      var totalMinutes = Math.max(0, Math.floor((Date.now() - vm.since) / 60000));
      var days = Math.floor(totalMinutes / 1440);
      var hours = Math.floor((totalMinutes % 1440) / 60);
      var minutes = totalMinutes % 60;
      return (days > 0 ? days + 'd ' : '') + hours + 'h ' + minutes + 'm';
    };
  }
});
